
/*
  This file is auto-generated by generate-icon-components.js. Do not edit it manually.
*/
import { html, css, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

export const FhiIconExpandSelector = "fhi-icon-expand";

/**
 * ## FhiIconExpand
 * 
 * {@link https://designsystem.fhi.no/?path=/docs/ikoner--docs}
 * 
 * @tag fhi-icon-expand
 * @element fhi-icon-expand
 */
@customElement(FhiIconExpandSelector)
export class FhiIconExpand extends LitElement {

  /**
   * Sets the color for the icon.
   * Should preferably be a color token. See [Color Tokens](https://designsystem.fhi.no/?path=/docs/design-tokens-farger--docs)
   * @type {string}
   */ 
  @property({ type: String }) color: string = "currentcolor";

  /**
   * Sets the size of the icon. Can be one of the predefined sizes, a number value, rem or px.
   * Number values are treated as px.
   * @type { 'xsmall' | 'small' | 'medium' | 'large' | number | string}
   */
  @property({ type: String }) size: 'xsmall' | 'small' | 'medium' | 'large' | number | `${number}px` | `${number}rem` = 'medium';

  private get _size(): string {
    switch (this.size) {
      case 'xsmall': 
        return '1rem'; 
      case 'small':
        return '1.25rem';
      case 'medium':
        return '1.5rem'; 
      case 'large':
        return '2rem'; 
      default:
        if (String(this.size).endsWith('px') || String(this.size).endsWith('rem')) {
          return String(this.size);
        }
        if (isNaN(Number(this.size))) {
          console.warn(`Invalid size value: ${this.size}. Falling back to default size '1.5rem'.`)
          return '1.5rem';
        }
        return `${this.size}px`;
    }
  }

  render() {
    return html`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${this._size}" height="${this._size}" fill="${this.color}"><path d="M8.47 14.47a.75.75 0 1 1 1.06 1.06l-4.72 4.72H7.8l.077.004a.75.75 0 0 1 0 1.492l-.077.004H3a.75.75 0 0 1-.75-.75v-4.8a.75.75 0 0 1 1.496-.077l.004.077v2.99zm6 0a.75.75 0 0 1 1.004-.052l.056.052 4.72 4.72V16.2a.75.75 0 0 1 1.5 0V21a.75.75 0 0 1-.75.75h-4.8a.75.75 0 0 1 0-1.5h2.99l-4.72-4.72-.052-.056a.75.75 0 0 1 .052-1.004M2.25 7.8V3A.75.75 0 0 1 3 2.25h4.8l.077.004a.75.75 0 0 1 0 1.492L7.8 3.75H4.81l4.72 4.72.052.056a.75.75 0 0 1-1.056 1.056L8.47 9.53 3.75 4.81V7.8l-.004.077a.75.75 0 0 1-1.492 0zm19.5 0a.75.75 0 0 1-1.5 0V4.81l-4.72 4.72a.75.75 0 1 1-1.06-1.06l4.72-4.72H16.2a.75.75 0 0 1 0-1.5H21l.077.004A.75.75 0 0 1 21.75 3z"/></svg>
    `;
  }
      
  static styles = css`
    :host {
      display: flex;
      max-height: min-content;
      max-width: min-content;
    }
  `;
  }
